// extracted by mini-css-extract-plugin
export default {"form":"styles_form__qHMIe","input":"styles_input__t4c91","photoContainer":"styles_photoContainer__gXYPs","image":"styles_image__Qd7Lg"};